module.exports = __webpack_public_path__ + "img/qrcode.3b363fc2.jpg";